<template>
<div class='widget-W0145V0001'>
  <div
    class="ist-elev-widget"
    data-test="AulaSecureWidget"
    v-bind:class="{ narrow: placement === 'narrow' || isMobileApp }"
  >

    <div v-if="tokenError" class="error" role="alert" aria-live="polite">{{ tokenError }}</div>

    <button
      class="btn-primary"
      type="button"
      aria-label="G&aring; til IST Elev - Meld frav&aelig;r"
      :disabled="!aulaToken"
      @click="redirectIdp"
    >
      <span class="btn-text">
        <span class="btn-label">G&aring; til IST Elev - Frav&aelig;r</span>
        <span class="btn-subtitle">&Aring;bner i browser</span>
      </span>
      <span class="btn-icon" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    placement: String,
    isMobileApp: Boolean,
    getAulaToken: Function,
    userProfile: {
      type: String,
      default: 'guardian',
    },
  },
  data: function () {
    return {
      loginUrl:
        'https://saml.borger.ist.dk/simplesaml/module.php/tabulexaulalogin/aula.php?appid=istelevborger',
      isOpening: false,
      aulaToken: undefined,
      tokenRefreshTimer: null,
      tokenError: '',
    };
  },
  methods: {
    refreshToken() {
      if (!this.getAulaToken) {
        this.tokenError = 'Aula token-funktion er ikke tilg&aelig;ngelig.';
        return;
      }
      const token = this.getAulaToken();
      if (token) {
        this.aulaToken = token;
        this.tokenError = '';
      }
    },
    buildLoginAction() {
      return this.loginUrl;
    },
    submitPost(targetUrl) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = targetUrl;
      form.target = 'IST_ELEV_GUARDIAN';
      const fields = {
        appid: 'istelevborger',
        aulaToken: this.aulaToken ?? '',
        userProfile: this.userProfile ?? '',
      };
      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });
      document.body.appendChild(form);
      try {
        form.submit();
      } finally {
        document.body.removeChild(form);
      }
    },
    async redirectIdp() {
      if (this.isOpening) {
        return;
      }
      if (!this.aulaToken) {
        this.tokenError = 'Aula-token mangler. Pr&oslash;v igen.';
        this.refreshToken();
        return;
      }
      this.isOpening = true;
      try {
        const targetAction = this.buildLoginAction();
        this.submitPost(targetAction);
      } catch (e) {
        this.tokenError = 'Kunne ikke kontakte login-tjenesten. Pr&oslash;v igen.';
      } finally {
        setTimeout(() => {
          this.isOpening = false;
        }, 1000);
      }
    },
  },
  mounted() {
    this.refreshToken();
    if (!this.tokenRefreshTimer) {
      this.tokenRefreshTimer = setInterval(() => this.refreshToken(), 5 * 60 * 1000);
    }
  },
  beforeUnmount() {
    if (this.tokenRefreshTimer) {
      clearInterval(this.tokenRefreshTimer);
    }
  },
};
</script>

<style lang="scss">
.widget-W0145V0001 {
.ist-elev-widget {
  padding: 10px;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}
.error {
  color: #b50050;
  font-size: 13px;
  margin-bottom: 10px;
}
.btn-primary {
  width: 100%;
  min-height: 64px;
  background: #0f4c75;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 16px;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.2s ease;
  box-shadow: 0 20px 35px rgba(15, 76, 117, 0.35);
}
.btn-primary:disabled {
  background: #9bb1c1;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.85;
}
.btn-primary:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 30px rgba(15, 76, 117, 0.35);
  background: rgba(15, 76, 117, 0.92);
}
.btn-primary:not(:disabled):active {
  transform: translateY(0);
  box-shadow: 0 10px 20px rgba(15, 76, 117, 0.3);
  background: rgba(15, 76, 117, 0.85);
}
.btn-primary:focus-visible {
  outline: 3px solid #66c2ff;
  outline-offset: 3px;
}
.btn-text {
  display: flex;
  flex-direction: column;
  text-align: left;
  letter-spacing: 0.01em;
}
.btn-label {
  font-size: 16px;
  line-height: 1.25;
}
.btn-subtitle {
  font-size: 13px;
  opacity: 0.85;
  font-weight: 400;
}
.btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  transition: transform 0.18s ease, background 0.2s ease;
}
.btn-primary:not(:disabled):hover .btn-icon {
  transform: translateX(6px);
  background: rgba(255, 255, 255, 0.25);
}
.btn-icon svg {
  display: block;
}

@media (max-width: 480px) {
  .btn-primary {
    min-height: 66px;
    border-radius: 11px;
    padding: 15px 18px;
  }
  .btn-label {
    font-size: 15px;
  }
  .btn-icon {
    width: 40px;
    height: 40px;
  }
}
}
</style>
